import dayjs from "dayjs";
import { getCurrentDatetime } from "./WorldTimeApi";

//* Saber si se le bloquean ciertos módulos por haber pasado la fecha límite para entrega de documentos del ciclo (date_documents_limit)
export const shouldBlockByDateDocumentsLimit = async (
    academicRecord,
    tiny_name = null
) => {
    //* En EAD no se bloque nadie
    if (tiny_name === "EAD") {
        return {
            shouldBlock: false,
            cycleDateDocumentsLimit: null,
            isDebtorDocuments: false,
        };
    }

    //* Si la fecha de inscripcíón es mayor a un año, no bloquear
    if (academicRecord?.inscription_date) {
        const isOlderThanOneYear =
            new Date(academicRecord.inscription_date) <
            new Date(new Date().setFullYear(new Date().getFullYear() - 1));

        if (isOlderThanOneYear) {
            return {
                shouldBlock: false,
                cycleDateDocumentsLimit: null,
                isDebtorDocuments: false,
            };
        }
    }

    let isDebtorDocuments =
        tiny_name !== "EAD"
            ? false
            : academicRecord?.documents_required?.some(
                  (dr) =>
                      dr.required &&
                      ["PENDIENTE", "RECHAZADO"].includes(dr.status)
              );

    if (academicRecord.status !== "SOLICITANTE" && isDebtorDocuments) {
        isDebtorDocuments = false;
    }

    //? Si no tiene la bandera de deudor, no se bloquea
    if (!academicRecord?.is_debtor_documents) {
        return {
            shouldBlock: false,
            cycleDateDocumentsLimit: null,
            isDebtorDocuments,
        };
    }

    //? Objeto retornado por defecto
    const defaultReturn = {
        shouldBlock: true,
        cycleDateDocumentsLimit: null,
        isDebtorDocuments,
    };

    if (!academicRecord) {
        return defaultReturn;
    }

    //? Si no tiene la relación de ciclos, se bloquea
    if (!academicRecord?.cycles?.length) {
        return defaultReturn;
    }

    const inscription_cycle_id = academicRecord?.inscription_cycle_id;

    //? Si no tiene ciclo de inscripción, se bloquea
    if (!inscription_cycle_id) {
        return defaultReturn;
    }

    //* Encontrar el ciclo de inscripción en la relación cycles
    const inscriptionCycle = academicRecord.cycles.find(
        (cycle) => cycle?.id === inscription_cycle_id
    );

    //? Si no se encuentra el ciclo de inscripción dentro de la relación, se bloquea
    if (!inscriptionCycle) {
        return defaultReturn;
    }

    const cycleDateDocumentsLimit = inscriptionCycle?.date_documents_limit;

    //? Si no se ha configurado la fecha límite para entrega de documentos en el ciclo, se bloquea
    if (!cycleDateDocumentsLimit) {
        return defaultReturn;
    }

    //? INICIO: Obtener fecha de API, si llega a fallar entonces usar la fecha local
    let today;
    try {
        const serverDate = await getCurrentDatetime();
        today = serverDate
            ? dayjs(serverDate).startOf("day")
            : dayjs().startOf("day");
    } catch (err) {
        console.warn("Fecha local", err);
        today = dayjs().startOf("day");
    }
    //? FIN: Obtener fecha de API, si llega a fallar entonces usar la fecha local

    //* Validar que la fecha límite para entrega de documentos aún no haya terminado
    const dateDocumentsLimit = dayjs(cycleDateDocumentsLimit).startOf("day");

    return {
        shouldBlock: today.isAfter(dateDocumentsLimit, "day"),
        cycleDateDocumentsLimit,
        isDebtorDocuments,
    };
};
